import {
    createStore,
    applyMiddleware
} from 'redux'
import {
    composeWithDevTools
} from 'redux-devtools-extension/developmentOnly'
import thunk from 'redux-thunk'
import rootReducer from './root-reducer'

 const createAppStore = (initialState) => {

    return createStore(
        rootReducer,
        initialState,
        composeWithDevTools(
            applyMiddleware(
                thunk
            )
        ),
    );
}

export default createAppStore;